module.exports = __webpack_public_path__ + "img/banner-titos.4c5bb5c3.png";